import { createSelector } from 'reselect';
import { HIDE_FILTERED, HIDE_TRASH } from '../../search-and-filter-schema/protected';
import { DEFAULT_CHAT_FILTERS } from './defaultChatFilters';
import { selectFilterValues } from './selectFilterValues';
const ignoreToggles = record => record.delete(HIDE_FILTERED).delete(HIDE_TRASH);
export const selectHasFiltersSet = createSelector([selectFilterValues], filterValues => {
  return !ignoreToggles(filterValues).equals(ignoreToggles(DEFAULT_CHAT_FILTERS));
});